/**
 * Business identity — required for Google Merchant Center transparency
 * (Misrepresentation policy). Displayed publicly in the footer, About and
 * Contact pages, and emitted in Organization JSON-LD.
 */
export const business = {
  legalName: "NiceGift",
  displayName: "NiceGift",
  /** מספר עוסק / ח.פ — must match Merchant Center business details */
  taxId: "200360790",
  street: "הראה 119",
  city: "רמת גן",
  postalCode: "",
  country: "IL",
  phone: "050-7113713",
  phoneE164: "+972507113713",
  /** Domain email — Merchant Center rejects free mailboxes (Gmail/Yahoo) */
  email: "info@nicegift.co.il",
  whatsapp: "+972507113713",
  hours: "זמינות בוואטסאפ בכל יום 8:00-22:00 · הגעה לחנות בתיאום מראש",
  returnDays: 30,
  social: [
    { label: "Instagram", url: "https://www.instagram.com/nicegift770/" },
  ] as { label: string; url: string }[],
  /** ISO date of the last site/content update — bump to signal freshness to Google (visible dates + sitemap) */
  lastUpdated: "2026-09-03",
} as const;

/** Hebrew-formatted freshness date, e.g. "3.9.2026" */
export const businessLastUpdatedHe = new Date(business.lastUpdated).toLocaleDateString("he-IL");

export const businessAddressLine = `${business.street}, ${business.city}, ישראל`;
